import { Collapse } from "reactstrap";
import styled from "styled-components";

const HeaderCollapse = styled(Collapse)`
  margin-top: 1.25rem;
  @media (min-width: 992px) {
    margin: 0;
  }
  margin-bottom: 0.5rem;
  &::after {
    content: "";
    display: none;
  }
`;

export default HeaderCollapse;
